/* eslint-disable */
// PikPak jsBridge API
import { v4 as uuid } from "uuid";
import { isIOS } from ".";

const _generateUUID = () => uuid().split("-").join("");

const _isPikPakPlatform = () => /pikpak/i.test(navigator.userAgent);

const _sendMessage = (fnName: string, params: Record<ObjectKeys, unknown> | string, callback: CallbackFn) => {
  if (!_isPikPakPlatform()) {
    return;
  }
  try {
    if (isIOS()) {
      const iosCallback = (error: any, data: any) => {
        callback && callback(data?.result || error);
      };
      window.PikPakJSBridge.sendMessage(fnName, params, iosCallback);
      return;
    }
    const callbackFnName = `PIKPAK__${fnName}__${_generateUUID()}`;
    // @ts-ignore
    window[callbackFnName] = (data: unknown) => {
      callback && callback(data);
      // @ts-ignore
      delete window[callbackFnName];
    };
    try {
      params = JSON.stringify(params);
    } catch {
      params = {};
    }
    window.PikPakJSBridge.sendMessage(fnName, params, callbackFnName);
  } catch (err) {
    console.error("[sendMessage: ]", err);
  }
};

type ObjectKeys = string | number | symbol;
type JBParams = Record<string | number | symbol, unknown>;
type CallbackFn = (p: unknown) => unknown;

type JBFn = (params: JBParams, callback: CallbackFn) => void;
export const promisifyBridge = (fn: JBFn, params: JBParams): Promise<any> => {
  return new Promise((resolve) => {
    if (!_isPikPakPlatform()) {
      return resolve('');
    }
    fn(params, response => {
      try {
        const result = typeof response === 'string' ? JSON.parse(response) : response;
        return resolve(result)
      } catch {
        return resolve(response);
      }
    });
  });
}

/**
 * 获取app登录用户信息, 比metaData接口获取的更多
 *
 */
export const getUserInfo = (params: JBParams, callback: CallbackFn) => {
  _sendMessage("ppGetUserInfo", params, callback);
};

/**
 *  params.openCamera: 0 相册, 1 相机
 *  params.maxNum: 最大选择图片数, 默认最多为3
 * */
export const openAlbumOrCamera = (params: JBParams, callback: CallbackFn) => {
  _sendMessage("ppPickPicture", params, callback);
};

/**
 * 关闭webview
 */
export const closeWebview = (params: JBParams, callback: CallbackFn) => {
  _sendMessage("ppFinishSelf", params, callback);
};

/**
 * 获取用户信息
 */
export const getAppMetaData = (params: JBParams, callback: CallbackFn) => {
  _sendMessage("ppGetAppMetaData", params, callback);
};

/**
 * 复制内容到粘贴板
 */
export const copyToClipboard = (params: JBParams, callback: CallbackFn) => {
  _sendMessage("ppCopyToClipBoard", params, callback);
};

/**
 * 借用客户端公参进行数据上报,
 * hubbleEventId: 事件ID
 * hubbleAttribute: 事件key
 * hubbleExData: 附带信息
 */
export const reportByPikPak = (params: JBParams, callback: CallbackFn) => {
  _sendMessage("ppReport", params, callback);
};

/**
 * 拉起系统分享框
 * @param { msg: string; } params
 * @param {*} callback
 */
export const callSystemShare = (params: JBParams, callback: CallbackFn) => {
  _sendMessage("ppActionSend", params, callback);
};

/**
 * 通知客户端网络检测结果
 * @param { connectivity: 'NONE' | 'NOT_SURE' | 'NORMAL' | 'GOOD' | 'WONDERFUL' } params
 * @param { (p: unknown) => unknown } callback
 * */
export const updateConnectivity = (params: JBParams, callback: CallbackFn) => {
  _sendMessage("ppUpdateConnectivity", params, callback);
};

/**
 * 使用客户端进行文件移动操作
 * @param { parent_id, user_id, file_ids } params
 * @param { (p: unknown) => unknown } callback
 */
export const moveFile = (params: JBParams, callback: CallbackFn) => {
  _sendMessage("ppMoveFileMetaData", params, callback);
};

/**
 * 在客户端文件夹中查看
 * @param { parent_id, user_id, file_ids } params
 * @param { (p: unknown) => unknown } callback
 */
export const viewInClientFolder = (params: JBParams, callback: CallbackFn) => {
  _sendMessage("ppWatchFolderMetaData", params, callback);
};

/**
 * 通知客户端登出
 */
export const clientLogout = (params: JBParams, callback: CallbackFn) => {
  _sendMessage("ppLoginOut", params, callback);
};

/**
 * 调用客户端系统toast
 * message: 提示内容
 */
export const showToast = (params: JBParams, callback: CallbackFn) => {
  _sendMessage("ppShowToast", params, callback);
};

/**
 * 获取客户端存在的日志的时间
 */
export const getLogTime = (params: JBParams, callback: CallbackFn) => {
  _sendMessage("ppGetLogTime", params, callback);
};

/**
 * 用户开启播放日志开关后，获取客户端回调
 */
export const fetchPlayerLogSwitch = (params: JBParams, callback: CallbackFn) => {
  _sendMessage("ppFetchAplayerLogSwitch", params, callback);
};

/**
 * 给客户端传递用户选择日志的时间
 */
export const fetchLogTime = (params: JBParams, callback: CallbackFn) => {
  _sendMessage("ppFetchLogTime", params, callback);
};

export const bindingToTheBot = (params: JBParams, callback: CallbackFn) => {
  _sendMessage("ppBindingTelegramBot", params, callback);
};

/**
 * 在客户端中用外部浏览器打开链接
 */
export const openActionView = (params: JBParams) => {
  _sendMessage("ppActionView", params, () => {});
}

/**
 * 从客户端获取登录授权码
 */
export const requestLoginAuthCode = (params: JBParams, callback: CallbackFn) => {
  _sendMessage("ppRequestLoginAuthCode", params, callback);
}